import {
    NodeJs,
    ReactJs,
    ReactNative,
    EcmaScript,
    VSCode,
    Strapi,
} from "../assets/courses";

export const courses = [
    {
        title: "دوره جامع نود جی اس",
        image: NodeJs,
        link: "https://doctorpesheto.ir/",
        info: ` 2 سال پیش که من شروع به تدریس نود جی اس کردم نود خیلی پرطرفدار بود و هنوزم هست که تا الان خیلی قابلیتهای جدید هم اضافه شده به Node که باعث شده بیشتر و بیشتر طرفدار زیادتری پیدا کنه و تبدیل به ابزاری شده که در همه جای دنیا توسط بهترین توسعه دهندگان استفاده میشه.`,
    },
    {
        title: "دوره صفر تا صد ری اکت",
        image: ReactJs,
        link: "https://doctorpesheto.ir/",
        info: `امروزه ری اکت جی اس به سرعت در حال تبدیل شدن به یک ابزار بسیار قدرتمند برای ساخت وب اپلیکیشن ها است و خیلی از معروفترین سایت ها از جمله فیسبوک , توییتر, نتفلیکس , یاهو , اینستاگرام و غیره همه در حال استفاده از این ابزار بسیار قدرتمند برای هرچه سریعتر و کارآمدتر کردن سایت و وب اپلیکیشن های خود هستند.`,
    },
    {
        title: "دوره جامع ری اکت نیتیو",
        image: ReactNative,
        link: "https://doctorpesheto.ir/",
        info: "یکی از آرزوهای من و شاید خیلی از برنامه نویس ها  این بوده که با یادگیری یک زبان برنامه نویسی برنامه هایی بنویسیم که روی پلتفرم های مختلف اجرا بشه.",
    },
    {
        title: "دوره جامع اکمااسکریپت",
        image: EcmaScript,
        link: "https://doctorpesheto.ir/",
        info: `اگر با جاوااسکریپت کار کرده باشید حتما در مورد اکمااسکریپت شنیدید،یا  اگر در موردش چیزی به گوشتون نخورده و هنوز جایی از ذهنتون رو مشغول کرده که تفاوت بین ECMAScript و جاوا اسکریپت چی هست باید بگم که
فقط یک بروزرسانی هست که در سال 2015 اتفاق افتاد با توجه به تاریخ خود جاوااسکریپت که در سال 1995 ساخته و ارائه شد `,
    },
    {
        title: "نکات حرفه ایی وی اس کد",
        image: VSCode,
        link: "https://doctorpesheto.ir/",
        info: `ویژوال استودیو کد امروزه جایگاه ویژه ایی بین ویرایشگرهای کد داره که روز به روز در حال گسترش هست و میشه گرفت توسعه دهنده و برنامه نویسی نیست که تا الان ازش استفاده ایی نکرده باشه. ویرایشگر کد شما محیط کاره شماست پس باید تمام ابزارهایی که میتونه کار شمارو برای انجام عملی آسونتر کنه رو یاد بگیرید. در این دوره هدف ما آموزش نکات کلیدی، ترفندهای حرفه ایی و افزونه هایی هست که هر توسعه دهنده و برنامه نویس باید باهاشون آشنا باشه.`,
    },
    {
        title: "دوره جامع استرپی",
        image: Strapi,
        link: "https://doctorpesheto.ir/",
        info: `استرپی یک سیستم مدیریت محتوای هدلس و اوپن سورس است که کاملاً با جاوا اسکریپت توسعه یافته و به صورت کامل قابل سفارشی سازی است .

با استفاده از سیستم مدیریت محتوای Strapi به سادگی می توانیم بهترین Api ها را طراحی کنیم و مهمتر از همه محتواها را به سادگی مدیریت کنیم.`,
    },
];
